import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to TechNova",
    title: "Innovating AI for Business Success and Future Growth",
    content: "Experience the future with our cutting-edge AI solutions. From personalized experiences to data-driven insights, we redefine possibilities.",
    buttonText: "About Us",
    buttonLink: "About-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to TechNova",
    title: "Driving Progress with Next-Gen AI Innovations",
    content:
      "Experience the future with our cutting-edge AI solutions. From personalized experiences to data-driven insights, we redefine possibilities.",
    buttonText: "About Us",
    buttonLink: "About-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to TechNova",
    title: "Transforming Possibilities with Smart AI Solutions",
    content: "Experience the future with our cutting-edge AI solutions. From personalized experiences to data-driven insights, we redefine possibilities.",
    buttonText: "About Us",
    buttonLink: "About-us",
  },
];

export default home;
